import React from "react";

import { Link } from "react-router-dom";

interface IProps {
  url: string;
  children: any;
  onClick?: any;
}

const ProcessAbsoluteUrlForChildren: React.FC<IProps> = (
  {
    url, children, onClick
  }: IProps) => {
  const rgExp = new RegExp('^(?:[a-z]+:)?//', 'i');
  if (rgExp.test(url)) {
    // absolute
    return (
      <a href={url} onClick={onClick}>{children}</a>
    )
  } else {
    if (url === null) {
      return null;
    }
    // relative
    return (
      <Link to={url} onClick={onClick}>{children}</Link>
    )
  }
};

export { ProcessAbsoluteUrlForChildren }